import React from "react";
import ChatMessage from "~/components/chat/ChatMessage";
import PulseLoader from "react-spinners/PulseLoader";
import { PlaySound } from "~/SoundUtils";
import "~/css/ChatHistory.css";

// PulseLoader用の定数
const pulseLoaderColor = "#4da8cb";
const pulseLoaderSize = 25;

const scrollSoundVolumeFactor = 0.4;

interface ChatHistoryLayout3Props {
  messages: { role: string; content: string; messageId?: string; contentColor?: string }[];
  chatHistoryRef: React.RefObject<HTMLDivElement | null>;
  showScrollToTopButton: boolean;
  scrollToTop: () => void;
  scrollToBottom: () => void;
  isListening: boolean;
  override: React.CSSProperties;
  volume: number;
  scrollButtonBottom: number;
  isButtonMode: boolean;
}

const ChatHistoryLayout3: React.FC<ChatHistoryLayout3Props> = ({
  messages,
  chatHistoryRef,
  showScrollToTopButton,
  scrollToTop,
  scrollToBottom,
  isListening,
  override,
  volume,
  scrollButtonBottom,
  isButtonMode,
}) => {
  return (
    <>
      <div
        className={`chat-history-layout-3${isButtonMode ? " button-mode" : ""}`}
        ref={chatHistoryRef}
      >
        {messages.map((message, index) => (
          <div key={index} className="message">
            <ChatMessage
              key={index}
              role={message.role}
              content={message.content}
              onImageLoad={scrollToBottom}
              messageId={message.messageId || ""}
              contentColor={message.contentColor}
            />
          </div>
        ))}

        <PulseLoader
          color={pulseLoaderColor}
          loading={!isListening}
          cssOverride={override}
          size={pulseLoaderSize}
        />

        <button
          className={`btn btn-secondary btn-circle scroll-to-top-button ${showScrollToTopButton ? "show" : ""}`}
          onClick={showScrollToTopButton ? scrollToTop : undefined}
          onMouseUp={() => PlaySound("pifo", scrollSoundVolumeFactor * volume)}
          style={{ bottom: `${scrollButtonBottom}px` }}
        >
          ⬆
        </button>
      </div>
    </>
  );
};

export default ChatHistoryLayout3;
